import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import store from '@App/app.store';

import CollectorLegend from '../../../CollectorLegend/CollectorLegend.jsx';

import './collector-legend-control.css';

class CollectorLegendControl {
  constructor(maximums) {
    this._maximums = maximums;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl flowing-water-legend-control';
    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <CollectorLegend maximums={this._maximums} />
      </StoreProvider>,
    );
    return this._container;
  }

  onRemove() {
    this._root?.unmount();
    this._container?.remove();
  }
}

export default CollectorLegendControl;
